import { render, staticRenderFns } from "./hzculture.vue?vue&type=template&id=3218a272&scoped=true"
import script from "./hzculture.vue?vue&type=script&lang=js"
export * from "./hzculture.vue?vue&type=script&lang=js"
import style0 from "./hzculture.vue?vue&type=style&index=0&id=3218a272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3218a272",
  null
  
)

export default component.exports